/**
 * 보드 배경 단색과 폴더 색이 함께 쓰는 단색 9종. 배열 순서가 피커 칸 순서다(색상환 순, 무채색 마지막).
 *
 * ⚠️ id 는 보드 배경·폴더 색으로 서버에 저장된다. 한 번 나간 id 는 바꾸지 않는다.
 */
export const SOLID_COLOR_IDS = [
  'RED',
  'YELLOW',
  'MINT',
  'GREEN',
  'BLUE',
  'VIOLET',
  'PURPLE',
  'PINK',
  'GRAY',
] as const;

export type SolidColorId = (typeof SOLID_COLOR_IDS)[number];

/**
 * 값은 ZUS 색 토큰이다(주석의 토큰과 같은지는 `solidColors.test.ts` 가 본다).
 * 토큰을 import 하지 않고 hex 로 적는 건 `board:verify-backgrounds` 가 보드 카탈로그를 번들러 없이
 * node 로 불러오기 때문이다 — 그 스크립트는 `@zep-us/zus` 경로를 풀지 못한다.
 */
export const SOLID_COLOR_HEX = {
  RED: '#FFE5EB', // red-100
  YELLOW: '#FFF6C3', // yellow-100
  MINT: '#D0FAF2', // mint-100
  GREEN: '#D0FAD4', // green-100
  BLUE: '#CFEAFF', // blue-100
  VIOLET: '#E7E4FF', // violet-100
  PURPLE: '#EBDBFF', // purple-100
  PINK: '#FDE8FD', // pink-50
  GRAY: '#E9EAF2', // gray-200
} as const satisfies Record<SolidColorId, string>;
